import { useState, useEffect } from "react";
import {
  getPatientInformation } from
"../../../services/rhapsody/ViewMrn";
import OtpVerification from "./OtpVerification";
import ResultDashboard from "./ResultDashboard";
import {
  fetchTranslationData } from
"../../../services/translation/translation";
import { ServiceTranslation } from "../../../utils/constants";
import { handleEmiratesIdChange } from "../handlers/FormHandlers";
import AlertDependent from "../../../common/AlertDependent";
import { getLayoutDirection } from "../../../utils/util";
import { Loader } from "../../../common/Loader";
import { isMobileApp } from "../../../utils/util";

const Dashboard = () => {
  const [emiratesId, setEmiratesId] = useState("");
  const [patientDetails, setPatientDetails] = useState({});
  const [alert, setAlert] = useState(false);
  const [currentPage, setCurrentPage] = useState("home");
  const [showModal, setShowModal] = useState(false);
  const [translationMap, setTranslationMap] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [warn, setWarn] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");

  const getPatientDetails = async () => {
    setAlert(false);
    if (!emiratesId.trim()) {
      setErrorMessage(translationMap?.enterValidEmiratesId || "Please enter valid emirates Id");
      return;
    }
    if (emiratesId.length !== 18) {
      setErrorMessage(translationMap?.emiratesIdShouldBeFifteen || "Emirates ID should be 15 digits");
      return;
    }
    try {
      setIsLoading(true);
      const info = await getPatientInformation(emiratesId);
      if (info?.data?.ReturnMessage === "Patient Not Found" || info?.data?.ReturnMessage === "Invalid EID") {
        setIsLoading(false);
        setWarn(false);
        setAlert(true);
      } else
      if (info?.data?.message === "otpBlocked")
      {
        setWarn(true);
        return;
      } else
      {
        setWarn(false);
        setAlert(false);
        const mobile = info?.data?.mobileNumber;
        const idInfo = info?.data?.id;
        setId(idInfo);
        setMobileNumber(mobile);
        setShowModal(true);
      }
    } catch (err) {



      // console.log(err.message);
    } finally {setIsLoading(false);}
  };

  useEffect(() => {
    fetchTranslationData(ServiceTranslation.FindMRN).then((result) => {
      setTranslationMap(result);
    });
  }, []);


  if (isLoading)
  {
    return (
      <Loader />);

  }

  return (
    <>
    <div className={` custombody_color ${getLayoutDirection()}`} id="sectionViewMrn">
      {currentPage === "home" &&
        <section
          className="w-100 clearfix ManageDependentMainSection"
          id="CoverPlanActive">
          
          <div className="container customContainer">
            {!isMobileApp() &&
            <div className="Title_Inner_Box">
                  <h1 className="MainTitleOne">{translationMap?.viewMrn}</h1>
                </div>
            }
            <div className="cover_inner_wrapper cover_inner_wrapper2">
              <div className="cover_main_box1">
                {alert &&
                <div className="AlertInnerBox AlertInnerBox2 YellowAlertInnerBox alert alert-dismissible fade show">
                    <button
                    type="button"
                    className="close"
                    data-dismiss="alert"
                    onClick={() => setAlert(false)}>
                    
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 7L7 17M7 7L17 17" stroke="#002F70" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                      </svg>
                    </button>
                    <div className="Icon_box">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a>
                        <span className="material-symbols-outlined">
                          warning
                        </span>
                      </a>
                    </div>
                    <div className="alert_text">
                      <h6>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a>{translationMap?.noInfoFound}</a>
                      </h6>
                      <p className="number_txt">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a>{translationMap?.noMrnLinkedText}.</a>
                      </p>
                    </div>
                  </div>
                }
                {warn &&
                <AlertDependent setError={setWarn} alert_text={translationMap?.otpBlocked || "Your OTP request is blocked for 5 minutes."} />
                }
                <div className="dependent_form_box">
                  <form>
                    <div className="form_inner_box">
                      <div className="inner_input_box">
                        <div className="input_box">
                          <label>{translationMap?.emiratesId}</label>
                          <div className="input_wrap">
                            <input
                              type="tel"
                              name="number"
                              placeholder={translationMap?.typeYourEmiratedId}
                              value={emiratesId}
                              onChange={(e) => handleEmiratesIdChange(e, setEmiratesId, setErrorMessage, translationMap)}
                              id="number"
                              style={{
                                borderColor: errorMessage ?
                                "#FF8F8A" :
                                "rgb(128 153 178)"
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  getPatientDetails();
                                }
                              }} />
                            
                            {errorMessage &&
                            <span id="text" style={{ color: "#FF8F8A" }}>
                                {errorMessage}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form_btn_box">
                      <span>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a
                          className="bluetrans_btn_link"
                          onClick={getPatientDetails}>
                          
                          {translationMap?.search}
                        </a>
                      </span>
                    </div>
                  </form>
                </div>
              </div>
              <div className="cover_main_box2"></div>
            </div>
          </div>
        </section>
        }

      {showModal &&
        <OtpVerification
          setShowModal={setShowModal}
          setCurrentPage={setCurrentPage}
          setPatientDetails={setPatientDetails}
          emiratesId={emiratesId}
          setEmiratesId={setEmiratesId}
          mobileNumber={mobileNumber}
          id={id}
          translationMap={translationMap} />

        }
      
      {currentPage === "result" &&
        <ResultDashboard
          patientDetails={patientDetails}
          setCurrentPage={setCurrentPage}
          setEmiratesId={setEmiratesId}
          translationMap={translationMap} />

        }
      </div>
    </>);

};

export default Dashboard;